import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../../BoxSizingStyle";
import { FontStyle } from "../../FontStyle";
import { Body2 } from "../../Typography";

export const StyledOptionGroupLi = styled.li`
  flex-direction: column;
  cursor: pointer;
`;
export const StyledOptionGroup = styled.div`
  ${tw`tw-select-none`}
  ${FontStyle}
  ${BoxSizingStyle}
`;

StyledOptionGroup.displayName = "StyledOptionGroup";

export const StyledOptionGroupHeader = styled.div`
  height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  margin: 6px 0;
  * {
    margin: auto 0;
  }
`;

StyledOptionGroupHeader.displayName = "StyledOptionGroupHeader";

export const StyledOptionGroupHeaderName = styled(Body2)`
  padding-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

StyledOptionGroupHeaderName.displayName = "StyledOptionGroupHeaderName";

export const StyledOptionGroupOption = styled.div<{ hover?: boolean }>`
  ${(props) =>
    props.hover &&
    css`
      background-color: var(--color-theme-200);
    `}
`;

StyledOptionGroupOption.displayName = "StyledOptionGroupOption";
